export const GET_ALL_DATA =  'GET_ALL_DATA';
export const UPDATE_ABOUT =  'UPDATE_ABOUT';
export const UPDATE_LANDING =  'UPDATE_LANDING';
export const SET_USER =  'SET_USER';
export const CLEAR_USER =  'CLEAR_USER';
export const SET_ADMIN_PAGE =  'SET_ADMIN_PAGE';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';